<template>
  <ts-panel>
    <ts-panel-wrapper class="tw-space-y-2">
      <div class="col-12 tw-space-y-4">
        <div class="row tw-space-y-2">
          <label class="form-col-label control-label">{{
            $t("levelSkillSubject.levelSkill")
          }}</label>
          <a-select
            class="col-md-12"
            show-search
            option-filter-prop="children"
            allowClear
            placeholder="Examination event|Skill|Trainer|Exam Date|Time"
            v-model="model.level_skill_id"
            :class="{ 'is-invalid': errors.has('level_skill_id') }"
            @change="onSkillChange"
          >
            <a-select-option
              v-for="(levelSkill, index) in formViewDatas['levelSkills']"
              :key="index"
              :value="levelSkill.level_skill_id"
            >
              {{ levelSkill.level_skill_name }} | Skill :
              {{ levelSkill.skill_name_en }} | LeveL:
              {{ levelSkill.skill_level_order }}
              <span
                v-if="levelSkill.is_accessor"
                class="badge bg-primary mr-2 tw-capitalize"
              >
                Accessor</span
              >
            </a-select-option>
          </a-select>
          <div class="invalid-feedback" v-if="errors.has('level_skill_id')">
            {{ errors.first("level_skill_id") }}
          </div>
        </div>
        <div class="col-12">
          <label class="form-label col-form-label col-md-12">{{
            $t("search")
          }}</label>
          <div class="col-md-12">
            <input type="text" v-model="search" class="form-control" />
          </div>
        </div>
        <h1 class="section-divider-underline">
          {{ $t("levelSkillSubject.subjectProfile") }}
        </h1>
        <div class="tw-overflow-auto row tw-max-h-screen" style="height: 550px">
          <ts-loading-banner :loading="loading">
            <table class="tw-w-full">
              <thead>
                <tr
                  class="tw-uppercase tw-bg-gray-200 tw-h-10 tw-sticky tw-top-0"
                >
                  <th class="tw-whitespace-nowrap tw-pl-2" style="width: 20%">
                    {{ $t("levelSkillSubject.subjectCode") }}
                  </th>
                  <th class="tw-whitespace-nowrap" style="width: 35%">
                    {{ $t("levelSkillSubject.nameEN") }}
                  </th>
                  <th class="tw-whitespace-nowrap" style="width: 35%">
                    {{ $t("levelSkillSubject.nameKH") }}
                  </th>
                  <th style="width: 10%"></th>
                </tr>
              </thead>
              <tbody class="tw-overflow-x-scroll">
                <tr
                  v-for="(subject, index) in subjects"
                  :key="index"
                  class="
                    tw-cursor-pointer
                    hover:tw-bg-gray-300
                    tw-w-full tw-h-10
                  "
                  @click="addNew(subject)"
                >
                  <td class="tw-whitespace-nowrap tw-pl-2">
                    {{ subject.subject_code }}
                  </td>
                  <td>
                    {{ subject.subject_name_en }}
                  </td>
                  <td>
                    {{ subject.subject_name_kh }}
                  </td>
                  <td
                    class="
                      tw-whitespace-nowrap tw-text-green-500 tw-text-center
                    "
                  >
                    <a-icon type="plus-circle" class="tw-text-lg" />
                  </td>
                </tr>
              </tbody>
            </table>
          </ts-loading-banner>
        </div>
      </div>
    </ts-panel-wrapper>
  </ts-panel>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapActions, mapState } from "vuex";

export default {
  name: "exam-schedule",
  props: ["value", "validation"],
  data() {
    return {
      search: "",
      loading: false,
      model: {},
      level_skill_id: null,
      errors: new Errors(),
      options: null,
    };
  },
  created() {
    this.model = this.value;
  },
  computed: {
    ...mapState("academic/levelSkillSubject", ["formViewDatas", "edit_data"]),
    subjects() {
      if (!this.formViewDatas["subjects"]) return [];
      return this.formViewDatas["subjects"]
        .filter(
          (sub) =>
            this.search
              .split(" ")
              .every((s) =>
                sub.subject_name_en.toLowerCase().includes(s.toLowerCase())
              ) ||
            this.search
              .split(" ")
              .every((s) =>
                sub.subject_code.toLowerCase().includes(s.toLowerCase())
              )
        )
        .slice(0, 400);
    },
  },
  methods: {
    ...mapActions("academic/levelSkillSubject", ["getFormViewData"]),
    async onSkillChange() {
      this.$emit("clearError");
      this.search = "";
      this.loading = true;
      await this.getFormViewData({
        index: "subjects,levelSkillSubjects",
        params: {
          fnName: "subjects,levelSkillSubjects",
          level_skill_id: this.model.level_skill_id,
        },
      });
      await this.pushData(this.formViewDatas["levelSkillSubjects"]);
      this.loading = false;
    },
    addNew(subject) {
      this.model.level_skill_subjects.push({
        subject_profile_id: subject.subject_profile_id,
        subject_code: subject.subject_code,
        subject_name_en: subject.subject_name_en,
        subject_name_kh: subject.subject_name_kh,
        subject_type_id: null,
      });

      this.formViewDatas["subjects"] = this.formViewDatas["subjects"].filter(
        function (i) {
          return i.subject_profile_id != subject.subject_profile_id;
        }
      );
    },
    pushData(levelSkillSubjects) {
      this.model.level_skill_subjects = [];
      levelSkillSubjects.forEach((el) => {
        this.model.level_skill_subjects.push({
          subject_profile_id: el.subject_profile_id,
          subject_code: el.subject_code,
          subject_name_en: el.subject_name_en,
          subject_name_kh: el.subject_name_kh,
          subject_type_id: el.subject_type_id ? el.subject_type_id : null,
        });
      });
    },
  },
  watch: {
    validation: {
      handler() {
        this.errors = new Errors(this.validation.errors);
      },
      deep: true,
    },
  },
};
</script>

<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  /* border-bottom: 1px solid #eee; */
  font-size: 16px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}
</style>
